module.exports = __webpack_public_path__ + "static/top_en_sp-3a4884f0d2ff394e8ac441094a65cc82.jpg";